import { z } from 'zod';
import { AppliedDiscountTypeSchema, DiscountScopeSchema } from './types';

export const AppliedDiscountSchema = z.object({
    discountId: z.string().optional(),
    name: z.string().min(1),
    type: AppliedDiscountTypeSchema.default('fixedAmount'),
    value: z.number().min(0).default(0),
    scope: DiscountScopeSchema.default('order'),
    amountApplied: z.number().min(0).default(0),
    reason: z.string().optional(),
    /** WHO approved it (attribution, never authorization) — see the model. */
    authorizedBy: z.string().optional(),
});

export const AppliedDiscountDataSchema = z.object({
    discountId: z.string().optional(),
    name: z.string().min(1),
    type: AppliedDiscountTypeSchema.optional().default('fixedAmount'),
    value: z.number().min(0).optional().default(0),
    scope: DiscountScopeSchema.optional().default('order'),
    amountApplied: z.number().min(0).optional().default(0),
    reason: z.string().optional(),
    authorizedBy: z.string().optional(),
});

export type AppliedDiscountSchemaType = z.infer<typeof AppliedDiscountSchema>;
export type AppliedDiscountDataSchemaType = z.infer<typeof AppliedDiscountDataSchema>;
